// Reactive (Vue.observable-based) sidebar-collapse state, shared between TopBar.vue
// (the toggle button) and SideBar.vue/TemplateDashboard.vue (which react to it), the
// same cross-component pattern modalStore.js uses.
import Vue from 'vue';

const state = Vue.observable({
    collapsed: false,
    // True while the mouse is hovering a collapsed sidebar, temporarily previewing
    // it at full width. Kept separate from `collapsed` (the locked toggle state) so
    // TemplateDashboard.vue's content margin never reflows during a hover preview -
    // only the sidebar itself and the header (which visually hugs its edge) follow it.
    hovering: false,
});

export function toggleSidebar() {
    state.collapsed = !state.collapsed;
}

export function isSidebarCollapsed() {
    return state.collapsed;
}

export function setSidebarHovering(value) {
    state.hovering = value;
}

// What the sidebar's own width/labels and the header's offset should follow:
// collapsed, unless a hover preview is currently expanding it.
export function isSidebarEffectivelyCollapsed() {
    return state.collapsed && !state.hovering;
}
